import React from 'react';
import theme from "styled-theming";
import styled from "styled-components";

import { ThemeType } from "../../shared/styles/theme";
import colors from "../../shared/styles/colors";


const NavigationItemChevronColor = theme("mode", {
  [ThemeType.light]: colors.black,
  [ThemeType.dark]: colors.white,
});

const StyledNavigationItemITag = styled.i`
  margin-left: 8px;
  font-weight: bold;
  color: ${NavigationItemChevronColor};
`;

export const NavigationItemChevron = () => {
    return <StyledNavigationItemITag className="ci-chevron_big_down" />
};
